/**
 * Tradutor único de erro desconhecido para texto de usuário.
 *
 * O erro sobe por `throw` e é traduzido uma vez só, na borda (query client,
 * hook, error boundary). Centralizar aqui evita que cada call site invente o
 * próprio texto e que um `catch` distraído mostre `[object Object]` na tela.
 * O que chega é `unknown` de verdade — rede, biblioteca de terceiro e `reject`
 * de promise podem carregar qualquer coisa —, por isso o narrowing é explícito
 * e sempre existe fallback.
 */

export const DEFAULT_ERROR_MESSAGE = 'Algo deu errado. Tente novamente.';

/** Extrai uma mensagem legível de um erro desconhecido. Nunca lança. */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message) return error.message;
  if (typeof error === 'string' && error) return error;
  return DEFAULT_ERROR_MESSAGE;
}
